module.exports = __webpack_public_path__ + "static/media/vignette_03.4809e42d.png";